const A_LIST = 'A-LIST'; // legacy tier name
// const LOYALLIST = 'LOYALLIST'; // legacy tier name
const THIRD_PARTY = 'THIRD-PARTY'; // legacy tier name
const BASE_3P = 'BASE-3P'; // new tier name for third party
const BASE_BCC = 'BASE-BCC'; // new tier name for loyallist
const TOL_PREFIX = 'TOL';
const UNL_PREFIX = 'UNL';
const BRONZE_PREFIX = 'BRONZE';
const SILVER_PREFIX = 'SILVER';
const GOLD_PREFIX = 'GOLD';
const PLATINUM_PREFIX = 'PLATINUM';

export const formatTierName = (tierName = '') => {
  if (typeof tierName === 'string' && tierName.length > 0) {
    if (tierName === A_LIST || tierName.startsWith(TOL_PREFIX)) {
      return 'TOL';
    }
    if (tierName.startsWith(UNL_PREFIX)) {
      return 'UNL';
    }
    if (tierName === THIRD_PARTY || tierName === BASE_3P || tierName === BASE_BCC) {
      return 'LOYALLIST';
    }
    if (tierName.startsWith(BRONZE_PREFIX)) {
      return 'BRONZE';
    }
    if (tierName.startsWith(SILVER_PREFIX)) {
      return 'SILVER';
    }
    if (tierName.startsWith(GOLD_PREFIX)) {
      return 'GOLD';
    }
    if (tierName.startsWith(PLATINUM_PREFIX)) {
      return 'PLATINUM';
    }
  }

  return tierName;
};

export default formatTierName;
